import { inheritLinks } from "./../inherit-links/inherit-links.js";
import cacher from "../intly.js/javascript/lib/cacher.js";

export const xmllib = {
  buildUrl: function (AppendUrl) {
    let siteUrl = window.location.protocol + "//" + window.location.host;
    if (AppendUrl) {
      siteUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        "/" +
        AppendUrl;
    }
    console.log(siteUrl);
    return siteUrl;
  },
  get: function (callback, url, status, number) {
    // if (cacher.retrieve("wp-json/wp/v2/" + url)) {
    //   console.log("cacher used");
    //   let data = cacher.retrieve("wp-json/wp/v2/" + url);
    //   let successful = true;
    //   callback(successful, data);
    //   inheritLinks();
    //   return data;
    // }

    // Get Current Language
    const getCurrentLanguage = () => {
      let lang = document.getElementById("current_language").dataset.language;
      if (lang == "en") {
        return (lang = "");
      }
      return lang + "/";
    };

    return fetch(this.buildUrl(getCurrentLanguage() + "wp-json/wp/v2/" + url))
      .then(function (response) {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status
          );
          return;
        }

        response.json().then(function (data) {
          var successful = true;
          if (response.status === 200) {
            //cacher.store("wp-json/wp/v2/" + url, data);
            callback(successful, data, status, number);
            inheritLinks();
          } else {
            callback(!successful);
          }
          return data;
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  },
};
